/*
 * @Author: Alan
 * @Date: 2023-06-01 21:58:05
 * @LastEditors: Alan
 * @LastEditTime: 2023-07-01 08:23:13
 * @Description: 在 Redux store 中定义了一个名为 game 的 slice，用于游戏数据相关处理。
 * @FilePath: /F1-M2-WEB-Code/store/gameSlice.js
 */
import { createSlice } from "@reduxjs/toolkit";
const isWindowObject = typeof window === "object";
const gameSlice = createSlice({
    name: "game",
    initialState: {
        //需要隐藏过滤的游戏
        gamesToFilter: ["SB2", "YBS"],
        isLoading: false,
        topTabIndex: "1",
        //页面顶部的导航菜单数据
        categories: isWindowObject
            ? JSON.parse(localStorage.getItem("GameSequenceData") || "[]")
            : [],
        //游戏产品页面 【平台】分类列表数据
        provider_Slot: [],
        provider_LiveCasino: [],
        provider_ESports: [],
        provider_P2P: [],
        provider_InstantGames: [],
        provider_KenoLottery: [],
        provider_Sportsbook: [],
        cacheGame: null,
        //用於 insufficient balance checking
        openGameData: null,
        smarticoVisible: false,
        // 控制 Smartico 維護 modal 顯示 / 按鈕行為
        smarticoMaintenanceModal: {
            visible: false,
            backHomePage: false,
        },
        aviatorGameId: null, //aviator遊戲id
    },
    reducers: {
        updateGameHide(state, action) {
            const gameToAdd = action.payload;
            if (!state.gamesToFilter.includes(gameToAdd)) {
                const updatedGamesToFilter = [
                    ...state.gamesToFilter,
                    gameToAdd,
                ];

                state.gamesToFilter = updatedGamesToFilter;
                console.log("state.gamesToFilter", state.gamesToFilter);
            }
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        setGameCategoriesData(state, action) {
            state.categories = action.payload;
        },
        set_Slot_ProviderData(state, action) {
            state.provider_Slot = action.payload;
        },
        set_LiveCasino_ProviderData(state, action) {
            state.provider_LiveCasino = action.payload;
        },
        set_ESports_ProviderData(state, action) {
            state.provider_ESports = action.payload;
        },
        set_P2P_ProviderData(state, action) {
            state.provider_P2P = action.payload;
        },
        set_InstantGames_ProviderData(state, action) {
            state.provider_InstantGames = action.payload;
        },
        set_KenoLottery_ProviderData(state, action) {
            state.provider_KenoLottery = action.payload;
        },
        set_Sportsbook_ProviderData(state, action) {
            state.provider_Sportsbook = action.payload;
        },
        setCacheGame(state, action) {
            state.cacheGame = action.payload;
        },
        setOpenGameData(state, action) {
            state.openGameData = action.payload;
        },
        setSmarticoVisible(state, action) {
            state.smarticoVisible = action.payload;
        },
        setSmarticoErrorModalVisible(state, action) {
            state.smarticoMaintenanceModal = {
                ...state.smarticoMaintenanceModal, // 保留其他狀態
                ...action.payload, // 更新特定屬性
            };
        },
        setAviatorGameId(state, action) {
            state.aviatorGameId = action.payload;
        },
        resetData(state) {
            state.gamesToFilter = ["SB2", "YBS"];
            state.cacheGame = null;
            state.openGameData = null;
        },
    },
});

export default gameSlice;

export const gameActions = gameSlice.actions;
